import { ShieldAlert, ShieldCheck, LogIn, CheckCircle2, XCircle, ChevronRight } from "lucide-react";

export function SecurityPanel({ security = {}, t, onGoto }) {
  const failed = security.failed_7d || 0;
  const logins = security.logins_7d || 0;
  const events = security.events || [];
  const alert = failed > 0;

  return (
    <div
      data-testid="control-security-panel"
      className="flex h-full flex-col rounded-xl border border-zinc-800 bg-zinc-900 p-5"
    >
      <div className="mb-4 flex items-center justify-between border-b border-zinc-800/60 pb-4">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-white">
          {alert ? <ShieldAlert className="h-4 w-4 text-rose-400" /> : <ShieldCheck className="h-4 w-4 text-emerald-400" />}
          {t("control.security")}
        </h3>
        <button
          onClick={onGoto}
          data-testid="security-panel-more"
          className="inline-flex items-center gap-1 text-xs font-medium text-zinc-400 transition-colors hover:text-white"
        >
          {t("control.details")} <ChevronRight className="h-3.5 w-3.5" />
        </button>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="rounded-lg border border-zinc-800/80 bg-zinc-950/40 p-3" data-testid="security-failed">
          <div className="flex items-center gap-2">
            <ShieldAlert className="h-4 w-4" style={{ color: alert ? "#f43f5e" : "#71717a" }} />
            <span className="font-mono text-xl font-bold" style={{ color: alert ? "#fb7185" : "#fafafa" }}>{failed}</span>
          </div>
          <div className="mt-1 text-[10px] font-medium uppercase tracking-wider text-zinc-500">{t("sec.failed7d")}</div>
        </div>
        <div className="rounded-lg border border-zinc-800/80 bg-zinc-950/40 p-3" data-testid="security-logins">
          <div className="flex items-center gap-2">
            <LogIn className="h-4 w-4 text-zinc-400" />
            <span className="font-mono text-xl font-bold text-white">{logins}</span>
          </div>
          <div className="mt-1 text-[10px] font-medium uppercase tracking-wider text-zinc-500">{t("sec.logins7d")}</div>
        </div>
      </div>

      <div className="mt-4 flex-1">
        <div className="mb-2 text-[10px] font-bold uppercase tracking-[0.18em] text-zinc-600">{t("sec.lastEvents")}</div>
        {events.length === 0 ? (
          <div className="py-3 text-xs text-zinc-500">{t("sec.allGood")}</div>
        ) : (
          <div className="flex flex-col gap-1.5">
            {events.slice(0, 4).map((e) => {
              const ok = e.ok ?? true;
              return (
                <div key={e.id} className="flex items-center gap-2 text-xs" data-testid={`security-event-${e.id}`}>
                  {ok ? <CheckCircle2 className="h-3.5 w-3.5 shrink-0 text-emerald-400" /> : <XCircle className="h-3.5 w-3.5 shrink-0 text-rose-400" />}
                  <span className="truncate text-zinc-300">{e.email || e.event}</span>
                  <span className="ml-auto shrink-0 text-zinc-600">{e.event}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
